module.exports = __webpack_public_path__ + "img/banner-02.0d764d48.png";